<template>
    <b-col class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Tra cứu, tìm kiếm nhóm tài sản</strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <b-row>
                            <b-col sm="6">
                                <b-form-group label="Phần mềm đồng bộ:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <sync-data-source :cached="true" :excluded="[2]" v-model="searchForm.syncSourceType" allowClear="true"></sync-data-source>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Cây phân loại tài sản:"
                                              label-for="unit"
                                              label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 :options="assetTypeTrees"
                                             v-model="searchForm.treeId"
                                             placeholder="--- Tất cả ---"
                                             :allowClear="true"
                                             style="width:100%"> </select2>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Nhóm tài sản lớn:"
                                              label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <treeselect id="input-parentname"
                                                ref="assetTypeGroupTree"
                                                v-model="searchForm.assetTypeGroupId"
                                                :max-height="390"
                                                placeholder="Nhập tên nhóm tài sản lớn"
                                                :options="assetTypeGroups" />
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Mã/Tên nhóm tài sản:"
                                              label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" id="search"
                                                  placeholder="Nhập tên hoặc mã ..."
                                                  v-model="searchForm.str">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <!--<b-row>
                            <b-col offset-md="3" md="6">
                                <b-form-group label=""
                                              label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>-->
                        <b-row class="justify-content-sm-center">
                            <b-col sm="6">
                                <b-form-group label="" :label-cols="4">
                                    <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>

                    <b-grid-tree :searchForm="searchForm"
                                 :gridOptions="gridOptions"
                                 dataUrl="master-data/asset-types"
                                 gridName="Danh sách nhóm tài sản"
                                 ref="assetTypeTable">
                        <template v-slot:actions>
                            <b-button size="md" @click.stop="exportExcel" variant="secondary">
                                Xuất Excel
                            </b-button>
                            <template v-if="authorize(['ManageAssetType']) && isBTCUser">
                                <router-link to="./create" tag="button" class="btn btn-primary" size="md">
                                    Thêm mới
                                </router-link>
                                <!--<b-button size="md" @click.stop="deletes" variant="danger" :disabled="isShowBtnDelete">
                                    Xóa
                                </b-button>-->
                            </template>
                        </template>
                        <template v-slot:cell(syncSourceType)="row">
                            {{ $store.getters.getSyncSourceType(row.value) }}
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <template v-if="authorize(['ViewAssetType'])">
                                    <b-button size="sm" :to="{ path: `./${row.item.id}/detail`}" title="xem" variant="info">
                                        Xem
                                    </b-button>
                                </template>
                                <template v-if="authorize(['ManageAssetType'])">
                                    <b-button size="sm" tag="button" variant="primary"
                                              :to="{ path: `./${row.item.id}/edit` }" title="sửa" class="mr5">
                                        Sửa
                                    </b-button>
                                    <b-button v-if="authorize(['ManageAssetType'])" size="sm" @click.stop="remove(row.item.id, row.index, $event.target)" class="mr-1" title="xóa" variant="danger">
                                        Xoá
                                    </b-button>
                                </template>
                            </b-button-group>
                        </template>
                    </b-grid-tree>
                </b-card>
            </b-col>
        </b-row>
    </b-col>
</template>
<script>
    import { mapState } from 'vuex'
    import { mixins } from '@/shared/mixins'

    export default {
        name: 'ListAssetType',
        mixins: [mixins],
        data() {
            return {
                searchForm: {
                    treeId: null,
                    assetTypeGroupId: null,
                    str: null,
                    syncSourceType: this.getSyncSourceTypeCache(null, [2]),
                },
                gridOptions: {
                    fields: [
                        { key: 'code', label: 'Mã nhóm tài sản', sortable: true },
                        { key: 'name', label: 'Tên nhóm tài sản', sortable: true },

                        { key: 'assetTypeTreeName', label: 'Cây phân loại tài sản', sortable: true, sortDirection: 'asc' },
                        { key: 'assetTypeGroupName', label: 'Nhóm tài sản lớn', sortable: true },
                        //{ key: 'unitName', label: 'Đơn vị áp dụng', sortable: true },
                        { key: 'syncSourceType', label: 'Phần mềm đồng bộ', sortable: true },
                        //{ key: 'description', label: 'Mô tả', sortable: true },
                        //{ key: 'calculationUnit', label: 'Đơn vị tính', sortable: true },
                        //{ key: 'startDate', label: 'Ngày bắt đầu', sortable: true },
                        //{ key: 'endDate', label: 'Ngày kết thúc', sortable: true },
                        //{ key: 'depreciationPeriod', label: 'Thời hạn sử dụng (khấu hao)', sortable: true },
                        //{ key: 'depreciationRate', label: 'Tỷ lệ khấu hao', sortable: true },
                        //{ key: 'amortizationPeriod', label: 'Thời hạn sử dụng (hao mòn)', sortable: true },
                        //{ key: 'amortizationRate', label: 'Tỷ lệ hao mòn', sortable: true },
                    ],
                    sortBy: 'code'
                },
                //treeId: null,
            }
        },
        computed: {
            ...mapState({
                assetTypeTrees: (state, getters) => getters.listAssetTypeTrees,
                assetTypeGroups: (state, getters) => getters.assetTypeGroupTree,
                //assetTypes: (state, getters) => getters.assetTypeTreeFull
            }),
            isDataOwner() {
                if (this.assetTypeSelected == null || this.assetTypeSelected, 0) return false;

                if (!this.assetType.unitId) {
                    return this.isAdmin;
                } else {
                    return this.authorize(['ManageAssetType'], this.assetType.unitId);
                }
            },
            //assetTypes() {
            //    this.assetTypeSelected = null;
            //    return this.$store.getters.getAssetTypeByTreeId(this.treeId || -1)
            //}
        },
        watch: {

        },
        created() {
            //this.treeId = this.assetTypeTrees.length > 0 ? this.assetTypeTrees[0].id : null;
            //this.loadAssetTypeDetail();
        },
        methods: {
            back() {
                this.$router.push({ path: '/master-data/asset-types/list' });
            },
            search() {
                this.$refs.assetTypeTable.refresh();
            },
            exportExcel() {
                this.$services.download('master-data/asset-types/excel');
            },
            remove(id) {
                var vm = this;
                if (id) {
                    if (confirm('Bạn có chắc chắn muốn xóa nhóm tài sản này?')) {
                        this.$services.delete(`master-data/asset-types/${id}`).done((response) => {
                            if (response) {
                                vm.$toastr.s('Xóa nhóm tài sản thành công !');
                                vm.search();
                            }
                            else {
                                vm.$toastr.e('Xóa nhóm tài sản không thành công,nhóm tài sản chứa nhóm tài sản con vui lòng xóa nhóm tài sản con trước!');
                            }

                        });
                    }
                }
                else {
                    vm.$toastr.e('Vui lòng chọn nhóm tài sản cần xóa');
                }
            },
        }
    }
</script>
<!--scoped-->
<style scoped>

    .mr5 {
        margin-right: 5px;
    }

    .mt15 {
        margin-top: 15px;
    }

    .border {
        border-radius: 5px;
    }
</style>
